import { render } from "./BaseLayout.vue?vue&type=template&id=20f5043c&scoped=true"
import script from "./BaseLayout.vue?vue&type=script&lang=js"
export * from "./BaseLayout.vue?vue&type=script&lang=js"

import "./BaseLayout.vue?vue&type=style&index=0&id=20f5043c&scoped=true&lang=css"

import exportComponent from "D:\\local_sites\\svn_sandra\\outside_sales_system\\apps\\sales_visits_pwa\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20f5043c"]])

export default __exports__